module.exports = __webpack_public_path__ + "04fbc2338253a2b1847ef1c7e7c0daf8.png";